import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import axios from 'axios'

export interface ProductGroup {
  name: string,
  key: string,
  id: number
}

@Module
export default class ProductGroupStore extends VuexModule {
  apiUrlRoot: string = '/product-groups'
  productGroups: ProductGroup[] = []

  @Mutation
  SET_PRODUCT_GROUPS (productGroups: ProductGroup[]) {
    this.productGroups = productGroups
  }

  @Action({ commit: 'SET_PRODUCT_GROUPS' })
  async loadProductGroups () {
    const result = await axios.get(this.apiUrlRoot, { withCredentials: true })
    const data: ProductGroup[] = result.data
    return data
  }

  @Action async addProductGroup (newProductGroup: ProductGroup) {
    debugger
    const result = await axios.post(`${this.apiUrlRoot}`, newProductGroup, { withCredentials: true })
    const data: ProductGroup = result.data
    return data
  }

  @Action async saveProductGroup (productGroupToSave: ProductGroup) {
    const result = await axios.post(`${this.apiUrlRoot}`, productGroupToSave, { withCredentials: true })
    return result
  }

  @Action async deleteProductGroup (productGroupToDelete: string) {
    const result = await axios.delete(`${this.apiUrlRoot}/${productGroupToDelete}`, { withCredentials: true })
    return result
  }

  get getProductGroups () {
    return this.productGroups
  }
}
